import {useEffect, useState} from "react";
import {HiOutlineChevronDoubleDown, HiOutlineChevronDoubleUp} from "react-icons/hi";

import styles from "./ScrollButton.module.scss";

export const ScrollButton = () => {
  const [showButton, setShowButton] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const element = document.documentElement;
      setIsAtBottom(element.scrollTop === element.scrollHeight - element.clientHeight);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [isAtBottom, showButton]);

  useEffect(() => {
    const onResize = new ResizeObserver(() => {
      const element = document.documentElement;
      setShowButton(element.scrollHeight > element.clientHeight);
    });
    onResize.observe(document.documentElement);
    return () => onResize.disconnect();
  }, []);

  return (
    showButton && (
      <div className={styles.scrollButton}>
        <button
          className="d-md-none btn btn-dark pulseTextH2"
          onClick={() => window.scrollTo({top: isAtBottom ? 0 : document.body.scrollHeight, behavior: "smooth"})}
        >
          {isAtBottom ? <HiOutlineChevronDoubleUp /> : <HiOutlineChevronDoubleDown />}
        </button>
      </div>
    )
  );
};
